import { DataService } from '../../dataService';
import { AxiosPromise } from 'axios';
import { Opportunity, ReasonCode } from '../models/OpportunityModels';
import { QualifyOpportunityParams } from '../models/APIModels';
import { ENV } from '../envUtils';

/**
 * Factory function that constructs the opportunity controller with HTTP methods for fetching, creating, submitting, canceling, qualifying, updating opportunities and managing reason codes.
 *
 * Each returned method wraps a DataService call — either a GET for fetch/list operations or a POST providing a route and form data for create/transition actions.
 */
export const opportunityController = (api: DataService) => ({
  //works, empty array
  getOpportunities: (): AxiosPromise<Opportunity[]> => api.get({ route: [`${ENV}/opportunities`] }),
  newOpportunity: (payload: Opportunity): AxiosPromise<void> =>
    api.post({
      route: [`${ENV}/opportunity/new`],
      formData: payload
    }),
  submitOpportunity: ({ aimOpportunity }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<void> =>
    api.post({
      route: [`${ENV}/opportunity/${aimOpportunity}/submit`]
    }),
  cancelOpportunity: ({ aimOpportunity }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<void> =>
    api.post({
      route: [`${ENV}/opportunity/${aimOpportunity}/cancel`]
    }),
  qualifyOpportunityLand: ({ aimOpportunity, comment }: QualifyOpportunityParams): AxiosPromise<void> =>
    api.post({
      route: [`${ENV}/opportunity/${aimOpportunity}/qualify/land`],
      formData: {
        comment: comment
      }
    }),
  qualifyOpportunityCeo: ({ aimOpportunity, comment }: QualifyOpportunityParams): AxiosPromise<void> =>
    api.post({
      route: [`${ENV}/opportunity/${aimOpportunity}/qualify/ceo`],
      formData: {
        comment: comment
      }
    }),
  qualifyOpportunityOperations: ({ aimOpportunity, comment }: QualifyOpportunityParams): AxiosPromise<void> =>
    api.post({
      route: [`${ENV}/opportunity/${aimOpportunity}/qualify/operations`],
      formData: {
        comment: comment
      }
    }),
  getOpportunity: ({ aimOpportunity }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<Opportunity> =>
    api.get({ route: [`${ENV}/opportunity/${aimOpportunity}`] }),
  getLandQualification: ({
    aimOpportunity
  }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<Opportunity> =>
    api.get({ route: [`${ENV}/opportunity/${aimOpportunity}/qualify/land`] }),
  getCeoQualification: ({ aimOpportunity }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<Opportunity> =>
    api.get({ route: [`${ENV}/opportunity/${aimOpportunity}/qualify/ceo`] }),
  getOperationsQualification: ({
    aimOpportunity
  }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<Opportunity> =>
    api.get({ route: [`${ENV}/opportunity/${aimOpportunity}/qualify/operations`] }),
  updateOpportunity: (payload: Opportunity): AxiosPromise<void> =>
    api.post({
      route: [`${ENV}/opportunity/${payload.aimOpportunity}`],
      formData: payload
    }),
  //works
  getReasonCodes: (): AxiosPromise<Array<ReasonCode>> => api.get({ route: [`${ENV}/reasoncodes`] }),
  //works
  getReasonCode: ({ aimReasonCode }: Pick<ReasonCode, 'aimReasonCode'>): AxiosPromise<ReasonCode> =>
    api.get({ route: [`${ENV}/reasoncode/${aimReasonCode}`] }),
  raiseOpportunityPriority: ({ aimOpportunity }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<void> =>
    api.get({ route: [`${ENV}/opportunity/${aimOpportunity}/priority/raise`] }),
  lowerOpportunityPriority: ({ aimOpportunity }: Pick<Opportunity, 'aimOpportunity'>): AxiosPromise<void> =>
    api.get({ route: [`${ENV}/opportunity/${aimOpportunity}/priority/lower`] })
});
